import React from 'react'
import PageNotFound from '../../components/page-not-found/page-not-found.component'

export default function NotFoundPage() {
    return (
        <PageNotFound />
    )
}
